
import Vue from "vue";
import { mapState } from "vuex";
import { currentTimeZone } from "@/helpers";
import { format, zonedTimeToUtc } from "date-fns-tz";
import { headersInterface } from "@/interfaces/Tables.interfaces";
import { constants } from "@/utils/constants";
import { startCase } from "lodash";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle";

export default Vue.extend({
  name: "DailyShiftList",
  components: {
    TempStarsTableTitle
  },
  data: () => {
    return {
      tableSearch: "",
      currentTZ: currentTimeZone(),
      hygienistTypeCode: constants.hygienistType,
      hygienistCountryCode: constants.countryCode
    };
  },
  computed: {
    ...mapState({
      tablename: "tablename",
      headers: "tableHeaders",
      content: "tableContent",
      countDays: "countDays"
    }),
    tableHeaders(): Array<headersInterface> {
      const tableColumns = constants.enabledColumns.dailyShiftList;
      const data = tableColumns.map(i => {
        return { align: "left", text: startCase(i), value: i };
      });
      return data;
    }
  },
  methods: {
    shiftDateFormat(item: string): string {
      return format(
        zonedTimeToUtc(item.slice(0, 10), this.currentTZ),
        "MMMM do yyyy"
      );
    }
  }
});
